import downloadReservations from './downloadReservations';
import downloadCounterData from './downloadCounterData';

export default [downloadReservations, downloadCounterData];
